import { useFormSubmit } from "@/hooks/useFormSubmit";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahgpa3oh653ivfvnurg";

const subjects = ["内容纠错与补充", "合作与投稿", "围观礼仪建议", "其他问题"];

export default function ContactForm() {
  const { status, message, handleSubmit } = useFormSubmit(SUBMIT_ADDR, "company_alt");

  const inputClass =
    "w-full h-11 px-4 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors";

  return (
    <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="w-full" noValidate>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm text-foreground-700 mb-2">
            称呼
          </label>
          <input id="contact-name" name="name" type="text" required placeholder="怎么称呼你" className={inputClass} />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm text-foreground-700 mb-2">
            邮箱
          </label>
          <input
            id="contact-email"
            name="email"
            type="email"
            required
            autoComplete="email"
            placeholder="方便我们回复你"
            className={inputClass}
          />
        </div>
      </div>

      <div className="mt-4">
        <label htmlFor="contact-subject" className="block text-sm text-foreground-700 mb-2">
          想聊的事情
        </label>
        <select id="contact-subject" name="subject" required defaultValue="" className={inputClass}>
          <option value="" disabled>
            请选择一个主题
          </option>
          {subjects.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      <div className="mt-4">
        <label htmlFor="contact-message" className="block text-sm text-foreground-700 mb-2">
          具体内容
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="把你发现的线索、想补充的时间点，或者任何建议写在这里（最多 500 字）"
          className="w-full px-4 py-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors resize-none"
        ></textarea>
      </div>

      <label className="note-aux-clip" aria-hidden="true">
        备用联系渠道
        <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" readOnly aria-hidden="true" />
      </label>

      <button
        type="submit"
        disabled={status === "loading"}
        className="mt-5 inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap"
      >
        <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center"></i>
        {status === "loading" ? "提交中…" : "发送给我们"}
      </button>

      {message ? (
        <p
          role="status"
          className={`mt-4 text-sm flex items-center gap-2 ${
            status === "error" ? "text-primary-600" : "text-secondary-700"
          }`}
        >
          <i
            className={`${
              status === "error" ? "ri-error-warning-line" : "ri-checkbox-circle-line"
            } w-4 h-4 flex items-center justify-center`}
          ></i>
          {message}
        </p>
      ) : null}
    </form>
  );
}